import Axios from "axios";
import config from "../config";

class apiClient {
    constructor(options) {
        const opt = options || {};
        this.$http = opt.$http || Axios;
        this.baseUrl = opt.baseUrl || config.baseUrl;
        this.jwt = opt.jwt;
    }

    async login(user, pwd) {
        console.log("login for " + user);
        try {
            const url = `${this.baseUrl}/login`;
            const response = await this.$http.post(url, {
                name: user,
                password: pwd
            });
            console.info("response", response);
            this.jwt = response.data.token;
            return response.data;
        } catch (e) {
            console.error(`cannot login '${user}'`, e);
            throw e;
        }
    }

    async profile() {
        const appName = config.appName;
        console.log(`profile for ${appName}`);
        try {
            const url = `${this.baseUrl}/profile/${appName}`;
            const response = await this.$http.get(url, {
                headers: {
                    "X-JwtToken": this.jwt
                }
            });
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot get application profile for ${appName}`, e);
            throw e;
        }
    }

    async localLogin(user, pwd) {
        console.log("localLogin for " + user);
        try {
            const url = `${this.baseUrl}/localLogin`;
            const response = await this.$http.post(url, {
                name: user,
                password: pwd
            });
            console.info("response", response);
            this.jwt = response.data.token;
            return response.data;
        } catch (e) {
            console.error(`cannot login '${user}'`, e);
            throw e;
        }
    }

    async localProfile() {
        const appName = config.appName;
        console.log(`localProfile for ${appName}`);
        try {
            const url = `${this.baseUrl}/localProfile/${appName}`;
            const response = await this.$http.get(url, {
                headers: {
                    "X-JwtToken": this.jwt
                }
            });
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot get application profile for ${appName}`, e);
            throw e;
        }
    }

    async changePassword(oldpwd, newpwd) {
        console.log("changePassword");
        try {
            const url = `${this.baseUrl}/user/changepassword`;
            const response = await this.$http.post(
                url,
                {
                    oldPassword: oldpwd,
                    newPassword: newpwd
                },
                {
                    headers: {
                        "X-JwtToken": this.jwt
                    }
                }
            );
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot changePassword'`, e);
            throw e;
        }
    }

    async uploadProject(data) {
        console.log("uploadProject ", data);
        try {
            const url = `${this.baseUrl}/uploadproject `;
            const response = await this.$http.post(url, data, {
                headers: {
                    "X-JwtToken": this.jwt
                }
            });
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot upload project`, e);
            throw e;
        }
    }

    async uploadFile(data) {
        console.log("uploadFile ", data);
        try {
            const url = `${this.baseUrl}/uploadfile `;
            const response = await this.$http.post(url, data, {
                headers: {
                    "X-JwtToken": this.jwt
                }
            });
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot upload file`, e);
            throw e;
        }
    }

    async getPasswordPolicies() {
        try {
            const url = `${this.baseUrl}/user/passwordrules`;
            const response = await this.$http.get(url, {
                headers: {
                    "X-JwtToken": this.jwt
                }
            });
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot get password policies'`, e);
            throw e;
        }
    }

    async sendPasswordResetRequest(email, backUrl) {
        console.log("sendPasswordResetRequest " + email + " url " + backUrl);
        try {
            const url = `${this.baseUrl}/user/resetpassword`;
            console.log("url", url);
            const params = {
                email
            };
            if (backUrl) {
                params["url"] = backUrl;
            }
            const response = await this.$http.post(url, params);
            console.info("response", response);
            return response.data;
        } catch (e) {
            console.error(`cannot send reset password to '${email}'`, e);
            throw e;
        }
    }
}

export default apiClient;
